export const DOMAIN = 'https://api-reader.neu.edu.vn/v2'

export const TOKEN = 'ACCESSTOKEN'

export const STATUS_CODE = {
  SUCCESS: 200,
  CREATED: 201,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  SERVER_ERROR: 500,
  TOO_MANY_REQUEST: 429,
  ECONNABORTED: 'ECONNABORTED',
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
}

export const LOGIN_UNAUTHORIZED = 'unauthorized'
